import { render, staticRenderFns } from "./ModalEditarFormulario.vue?vue&type=template&id=1f950b18"
import script from "./ModalEditarFormulario.vue?vue&type=script&lang=js"
export * from "./ModalEditarFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports